import { configByMode } from "./modes";

const configMode = __FORTH_LEAF_CONFIG_MODE__;
const config = configByMode[configMode as keyof typeof configByMode];

if (!config) {
  throw new Error(`No Forth Leaf configuration exists for Vite mode: ${configMode}`);
}

export default Object.freeze(config);
